import React from 'react';
import { graphql } from 'gatsby';
import { DevelopmentFeed as DevelopmentFeedComponent } from '../../DevelopmentFeed';

export const DevelopmentFeed = ({ data, ...rest }) => <DevelopmentFeedComponent {...data} {...rest} />;

export const DevelopmentFeedQuery = graphql`
  fragment DevelopmentFeed on KFH_UmbracoDevelopmentFeedComponentType {
    title
    backgroundColour
    developments {
      properties {
        edges {
          node {
            __typename
            relativeUrl
            address {
              streetname
              town
              outwardCode
            }
            ... on KFH_DevelopmentResalePropertyType {
              developmentName
              developmentMaxPrice
              developmentMinPrice
              plots {
                plotNumber
                propertyType
                bedrooms
              }
              images {
                developmentImages {
                  imagePath
                  largestImagePath
                  width
                  height
                  filename
                  mimeType
                  ...PropertyGallerySmallImage
                }
              }
            }
          }
        }
      }
    }
  }
`;
